// The card image for pages that have no picture of their own.
//
// Blog posts and the listing pages carry their own; services, projects, the
// policy pages and 404 do not, and a card with no image is a plain line of
// text in a feed. Their hero photos are not a substitute: they are a mix of
// WebP and JPEG, and LinkedIn's handling of WebP in og:image is unreliable
// enough that half the pages would silently lose their picture.
//
// 1200x630 -- the size LinkedIn, Facebook and WhatsApp all render around, so
// nothing upscales it.
export const SOCIAL_IMAGE = "https://www.savorka.in/og-image.jpg";
